import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PiRabbit, PiRabbitFill } from "react-icons/pi";
import {
  IoLayersOutline, IoLayers,
  IoBarChartOutline, IoBarChart,
  IoWarningOutline, IoWarning,
  IoShieldOutline, IoShield,
  IoCheckmarkDoneOutline, IoCheckmarkDone,
  IoDocumentTextOutline, IoDocumentText,
  IoStorefrontOutline, IoStorefront,
  IoSettingsOutline, IoSettings,
} from "react-icons/io5";

const NAV_ITEM_BASE =
  "flex flex-col items-center justify-center gap-1 w-full py-3 px-1 relative transition-colors duration-150 hover:bg-white group";

const NavItem = ({ to, label, IconOutline, IconFilled, exact = false }) => {
  const location = useLocation();
  const active = exact
    ? location.pathname === to
    : location.pathname.startsWith(to);

  return (
    <Link
      to={to}
      className={`${NAV_ITEM_BASE} ${active ? "bg-white" : ""}`}
    >
      {active && (
        <span className="absolute left-0 top-1/2 -translate-y-1/2 w-[3px] h-8 bg-[#3b3b3b] rounded-r-full" />
      )}
      {active
        ? <IconFilled size={22} className="text-[#3b3b3b]" />
        : <IconOutline size={22} className="text-[#8a9099] group-hover:text-[#3b3b3b]" />
      }
      <span
        className={`text-[10px] leading-none tracking-tight text-center ${
          active ? "text-[#3b3b3b] font-semibold" : "text-[#8a9099] group-hover:text-[#3b3b3b]"
        }`}
      >
        {label}
      </span>
    </Link>
  );
};

const Sidebar = (props) => {
  const { t } = useTranslation();
  const { profile } = props;
  const { role } = profile;

  return (
    <div className="relative flex flex-col w-16 h-full bg-[#F4F5F6] border-r border-gray-200">
      <nav className="flex flex-col flex-1 min-h-0">
        <div className="flex-1 min-h-0 overflow-y-auto pb-16 pt-1">

          <NavItem
            to="/risk_center"
            label={t("sidebar.riskCenter")}
            IconOutline={IoLayersOutline}
            IconFilled={IoLayers}
          />

          {(role === "Admin" || role === "Auditor") && (
            <NavItem
              to="/dashboards"
              label={t("sidebar.dashboard")}
              IconOutline={IoBarChartOutline}
              IconFilled={IoBarChart}
            />
          )}

          <NavItem
            to="/risk"
            label={t("sidebar.risk")}
            IconOutline={IoWarningOutline}
            IconFilled={IoWarning}
            exact
          />

          {role === "Admin" && (
            <NavItem
              to="/controls"
              label={t("sidebar.controls")}
              IconOutline={IoShieldOutline}
              IconFilled={IoShield}
            />
          )}

          <NavItem
            to="/actions"
            label={t("sidebar.actions")}
            IconOutline={IoCheckmarkDoneOutline}
            IconFilled={IoCheckmarkDone}
          />

          {(role === "Admin" || role === "Auditor") && (
            <NavItem
              to="/audit"
              label={t("sidebar.audit")}
              IconOutline={IoDocumentTextOutline}
              IconFilled={IoDocumentText}
            />
          )}

          <NavItem
            to="/chat"
            label={t("sidebar.askRabo")}
            IconOutline={PiRabbit}
            IconFilled={PiRabbitFill}
          />

          {role === "Admin" && (
            <NavItem
              to="/marketplace"
              label={t("sidebar.market")}
              IconOutline={IoStorefrontOutline}
              IconFilled={IoStorefront}
            />
          )}

        </div>

        <div className="absolute bottom-0 left-0 right-0 border-t border-gray-200 bg-[#F4F5F6]">
          {role === "Admin" && (
            <NavItem
              to="/admin"
              label={t("sidebar.admin")}
              IconOutline={IoSettingsOutline}
              IconFilled={IoSettings}
            />
          )}
        </div>
      </nav>
    </div>
  );
};

const mapStateToProps = (state) => ({
  profile: state.profile.profile,
});

export default compose(connect(mapStateToProps))(Sidebar);
